/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name no-console no-magic-numbers no-null-keyword

import { mockRegistry, toIsoDate } from '@gh/core-data';
import { toString } from '@gh/core-util';
import { date } from 'faker';
import { range } from 'lodash';

const PROFILES_ME = {
  locale: 'en_US',
};

const PURCHASE_ORDERS = range(1000).map((i) => ({
  jobOrderId: `jo:${toString(i)}`,
  orderNumber: 0,
  status: {
    0: 'Pending',
    1: 'Accepted',
    2: 'Rejected',
  }[i % 3],
  statusValue: (i % 3) + 1,
  deliveryDate: toIsoDate(date.past()),
}));

export const SUPPLIER_MOCK_DATA = mockRegistry(
  // mockRequest({ url: '/sp/rest/profiles/me', data: PROFILES_ME }),
  // mockRequest({
  //   url: '/sp/rest/purchase-orders/:orderId/accept',
  //   data: ({ params: { orderId } }: any) => {
  //     const order = find(PURCHASE_ORDERS, { jobOrderId: orderId });
  //
  //     if (order) {
  //       order.statusValue = 2;
  //       order.status = 'Accepted';
  //       return order;
  //     }
  //   },
  // }),
  // mockRequest({
  //   url: '/sp/rest/purchase-orders/:orderId/reject',
  //   data: ({ params: { orderId } }: any) => {
  //     const order = find(PURCHASE_ORDERS, { jobOrderId: orderId });
  //
  //     if (order) {
  //       order.statusValue = 3;
  //       order.status = 'Rejected';
  //       return order;
  //     }
  //   },
  // }),
  // mockPagination({
  //   url: '/sp/rest/purchase-orders',
  //   data: ({ query: { showRejected }}) =>
  //     showRejected === 'true' ? PURCHASE_ORDERS : PURCHASE_ORDERS.filter(({ statusValue }) => statusValue !== 3),
  // }),
);
